<template>
  <div>
    <h5 class="pb-2 border-bottom" v-if="!hideHeader">
      {{ exception.message }}
    </h5>
    <pre class="text-danger mb-3 border3">
        {{ stacktrace }}
    </pre>
  </div>
</template>

<script>
export default {
  props: ["exception", "hideHeader"],
  computed: {
    stacktrace() {
      if (this.exception && this.exception.response) {
        const data = this.exception.response.data;
        if (typeof data === "string") return data;
        if (typeof data === "object") return JSON.stringify(data, null, 1);
        return data;
      }

      return this.exception;
    }
  }
};
</script>
